import { ImageContent, LANDING_TYPE_CONTENT, PassageContent, } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import { IPrimitiveProps } from "../../section/Primitive"
import ImagePrimitive from "../ImagePrimitive"
import PassageImageContainer from "./PassageImageContainer"
import PassageItemEditForm from "../../landing-edit/editors/passage/PassageItemEditForm"

/* Protopia Ecosystem component */  
const HorizontalPassagePrimitive = (props: IPrimitiveProps): JSX.Element => {  
    const primitive: PassageContent  = useComponentData<PassageContent>(( props.primitive || {dimensions: {}} ) as PassageContent )
    if(!primitive.items?.length) return <></>
    const items: ImageContent[] = primitive.items 
    return !!items.length
        ?
        <div 
            className={`pe-primitive-container landing-passage-primitive landing-passage-${primitive.id} ${primitive.className || ""} justify-content-start `} 
            style={{ gap: primitive.gap }}
            data-primitive-type={ primitive[ "data-primitive-type" ] }
        > 
            <div className="passage-container d-flex flex-wrap">    
                {
                    items 
                        .map((item: any, i) => { 
                            const width  = "auto"
                            const height = primitive.itemHeight || "100%"
                            const _primitive : ImageContent = { 
                                ...item, 
                                data: {
                                    ...item,
                                    hover_size: primitive.hover_size,
                                    src_type: primitive.src_type || "div",
                                },
                                position: {
                                    height,
                                    width
                                },
                                border: primitive.border,
                                type: LANDING_TYPE_CONTENT.IMAGE,
                                className: `${item.className || ""} ${primitive.className || ""}`, 
                            }
                            return <PassageImageContainer 
                                key={item.id} 
                                width={width} 
                                height={height} 
                                i={i} 
                                animated={primitive.animated}  
                                animated_delay={primitive.animated_delay}
                            >
                                <PassageItemEditForm i={ i } primitive={ _primitive } items={items}  >
                                    <ImagePrimitive 
                                        i={i}
                                        primitive={ _primitive as ImageContent }
                                    />
                                </PassageItemEditForm>
                            </PassageImageContainer>
                        })
                }  
            </div>
        </div>
        :
        <></>
}

export default HorizontalPassagePrimitive